import React, { createContext, useEffect, useReducer } from 'react';
import { reducer } from './state/reducer';
import { ACTIONS } from './state/actions';
import { connect } from 'react-redux';
import {
  COURSE_GUIDE_LABEL,
  REPORTS_LABEL,
} from 'chameleon-src/components/SidebarWrapperTwoLevels/constants';

export const BreadcrumbContext = createContext({});

const BreadcrumbProvider = (props) => {
  const {
    children,
    params: { subject },
    prevLocation,
  } = props;

  let prevRoute = prevLocation || `/${subject}/home`;

  const determinePreviousPageName = (prevPath) => {
    if (prevPath.includes('dashboard') || prevPath.includes('activities')) {
      return REPORTS_LABEL;
    }
    if (prevPath.includes('assignments') || prevPath.includes('assessments')) {
      return 'Resources & Assignments';
    }
    if (prevPath.includes('question_bank')) {
      return 'Question Bank';
    }

    return COURSE_GUIDE_LABEL;
  };

  let initialState;
  if (prevRoute.includes('mode=search')) {
    initialState = {
      breadCrumbs: [
        {
          to: `/${subject}/home`,
          text: COURSE_GUIDE_LABEL,
        },
      ],
    };
  } else {
    initialState = {
      breadCrumbs: [
        {
          to: prevRoute,
          text: determinePreviousPageName(prevRoute),
        },
      ],
    };
  }

  const [state, dispatch] = useReducer(reducer, initialState);
  const { breadCrumbs } = state;

  useEffect(() => {
    dispatch({
      type: ACTIONS.updatePreviousPageRoute,
      payload: {
        text: determinePreviousPageName(prevRoute),
        to: prevRoute,
      },
    });
  }, [prevRoute]);

  return (
    <BreadcrumbContext.Provider
      value={{ dispatch, breadCrumbs, determinePreviousPageName, ACTIONS }}
    >
      {children}
    </BreadcrumbContext.Provider>
  );
};

const mapStateToProps = () => {
  return {
    prevLocation: localStorage.getItem('PREV_ROUTE'),
  };
};

export default connect(mapStateToProps)(BreadcrumbProvider);
